export const productTranslations = {
  'en': {
    'productsLabel': 'Products',
    'manageADPProductsLabel': 'Edit ADP Products',
    'oneTimeProductsLabel': 'One Time Products',
    'pointsBalanceLabel': 'Points Balance',
    'psvBalanceLabel': 'PSV',
    'subtotalLabel': 'Subtotal',
    'shippingLabel': 'Shipping',
    'taxLabel': 'Tax',
    'totalLabel': 'Total',
    'taxInfo': 'Taxes are calculated on the corresponding value of all items in your cart, including the value of free items.',
    'redeemPointsLinkText': 'Redeem Points'
  },
  'es': {
    'productsLabel': 'Productos',
    'manageADPProductsLabel': 'Editar productos ADP',
    'oneTimeProductsLabel': 'Productos One Time',
    'pointsBalanceLabel': 'Puntos Balance',
    'psvBalanceLabel': 'Balance de PSV',
    'subtotalLabel': 'Total parcial',
    'shippingLabel': 'Envío',
    'taxLabel': 'Impuesto',
    'totalLabel': 'Total',
    'taxInfo': 'Los impuestos se calculan sobre el valor correspondiente de todos los artículos en su carrito, incluido el valor de los artículos gratuitos.',
    'redeemPointsLinkText': 'canjear los puntos'
  },
  'zh': {
    'productsLabel': '产品',
    'manageADPProductsLabel': '管理ADP产品',
    'oneTimeProductsLabel': '一次性产品',
    'pointsBalanceLabel': '积分余额',
    'psvBalanceLabel': 'PSV余额',
    'subtotalLabel': '小计',
    'shippingLabel': '运费',
    'taxLabel': '税',
    'totalLabel': '总额',
    'taxInfo': '税费根据购物车中所有商品的相应价值计算，包括免费商品的价值。',
    'redeemPointsLinkText': '积分兑换'
  }
};
